import { Injectable } from '@angular/core';
import { interval, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IntervalsService {
  intervals = new Map<number, Observable<number>>();
  provide(seconds: number): Observable<number> {
    if(this.intervals.has(seconds)) {
      return this.intervals.get(seconds)!;
    }
    const intval = interval(seconds);
    this.intervals.set(seconds, intval);
    return intval;
  }
}
